import styled from "styled-components/macro"
import Color from "../../../constants/Color"

export const ContainerMain = styled.div`
  width: 100%;
  background: linear-gradient(90.25deg, rgba(17, 24, 39, 0.594) 0.2%, rgba(17, 24, 39, 0.747) 50.51%, rgba(17, 24, 39, 0.9) 99.78%), url("https://www.themoviedb.org/t/p/w1920_and_h800_multi_faces/gNBCvtYyGPbjPCT1k3MvJuNuXR6.jpg");
  background-size: cover;
  object-fit: cover;
  background-repeat: no-repeat;
  background-position: center;
`
export const Wrapper = styled.div`
  padding: 32px 0;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
`
export const Inner = styled.div`
  display: flex;
  color: ${Color.gray300};
  padding: 0 16px;
`
export const Thumbnail = styled.div`
  width: 160px;
  height: 200px;
  border-radius: 2px;
  overflow: hidden;

  @media (min-width: 768px) {
    width: 308px;
    height: 386px;
  }

  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`
export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 12px;

  @media (min-width: 640px) {
    padding-left: 24px;
  }
  @media (min-width: 768px) {
    padding-left: 36px;
  }
`

export const Title = styled.h2`
  font-size: 18px;
  color: ${Color.white};
  margin-bottom: 6px;

  @media (min-width: 1280px) {
    font-size: 28px;
  }
`
export const Subtitle = styled.p`
  font-size: 16px;
  margin-bottom: 8px;
`

export const SecondHeadline = styled.h4`
  display: none;

  @media (min-width: 1280px) {
    display: block;
    font-size: 22px;
    margin-bottom: 6px;
    color: ${Color.gray100};
  }
`

export const Overview = styled.p`
  display: none;

  @media (min-width: 1280px) {
    display: block;
    width: 640px;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.01em;
  }
`
